import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SweetAlertHelper } from 'app/core/helpers/sweet-alert-helper.service';
import { Subscription } from 'rxjs/Subscription';
import { RiderAdminuserService } from '../../../../core/services/rider-adminuser.service';
import { T2CardComponent } from '../../../../trip2-theme/components/t2-card/t2-card.component';
import { T2LoadingService } from '../../../../trip2-theme/components/t2-loading/t2-loading.service';
import { constant } from 'app/app.constants';

@Component({
  selector: 'app-rider-mobile-app',
  templateUrl: './rider-mobile-app.component.html',
  styleUrls: ['./rider-mobile-app.component.scss']
})
export class RiderMobileAppComponent implements OnInit, OnChanges, OnDestroy {

  private adminuserid: number;
  private adminuser = {};
  private formMobileApp: FormGroup;
  @Input() formMobile: FormGroup;
  @Input() riderId: number;
  @ViewChild('passwordModal') private passwordModal: T2CardComponent;
  private subscription: Subscription[] = [];
  MASK_PHONE = constant.MASK_PHONE;
  constructor(
    private _service: RiderAdminuserService,
    private fb: FormBuilder,
    private _loading: T2LoadingService,
    private sweetAlertHelper: SweetAlertHelper,
  ) {
    this.createForm();
  }

  ngOnInit() {
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['riderId']) {
      this.getRiderAdminUser(this.riderId);
    }
  }

  /**
   *@name createForm
   * @description crea el form
   * */
  createForm(): void {
    this.formMobileApp = this.fb.group({
      firstname: '',
      middleinitial: '',
      lastname: '',
      phone: '',
      emailaddress: '',
      isactive: '',
    });
  }

  /**
   *@name getRiderAdminUser
   * @description trae los datos del rider
   * @param id = riderId
   * */
  getRiderAdminUser(id: number): void {
    this._loading.show('Loading data');
    this.subscription.push(
      this._service.getAppData(id)
        .finally(() => this._loading.hiden())
        .subscribe({
          next: (success: any) => {
            this.assignObjectValues(success);
          },
          error: (error: any) => {
            this.sweetAlertHelper.createCustomAlert({
              title: 'Error',
              text: error.message,
              type: 'error',
            });
          }
        })
    );
  }

  /**
   *@name assignObjectValues
   * @description asigna los valores de el objeto sin referencia y pasa al form.
   * @param obj = Objeto
   * */
  assignObjectValues(obj: any): void {
    if (obj && obj.userprofileid) {
      this.adminuserid = obj.userprofileid;
      this.formMobileApp.patchValue(this.setterDataForm(obj));
    } else {
      this.resetData();
    }
  }

  /**
   *@name resetData
   * @description Borra los datos
   * */
  resetData(): void {
    this.adminuserid = null;
    this.adminuser = {};
    this.formMobileApp.reset(this.setterDataForm());
  }

  setterDataForm(data: any = null): Object {
    let obj = {
      firstname: '',
      middleinitial: '',
      lastname: '',
      phone: '',
      emailaddress: '',
      isactive: '',
    };

    if (data) {
      obj = {
        firstname: data.firstname,
        middleinitial: data.middleinitial,
        lastname: data.lastname,
        phone: data.phone,
        emailaddress: data.emailaddress,
        isactive: data.isactive,
      };
    }

    return obj;
  }

  /**
   *@name onResetPassword
   * @description abre la modal para cambiar el password
   * */
  openPasswordModal() {
    this.passwordModal.open();
  }

  /**
   *@name onCloseModal
   * @description abre la modal para cambiar el password
   * */
  closePasswordModal() {
    this.passwordModal.close();
    this.getRiderAdminUser(this.riderId);
  }

  ngOnDestroy(): void {
    this.subscription.forEach((item) => item.unsubscribe());
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/rider/components/rider-mobile-app/rider-mobile-app.component.ts